import React from 'react';
import { visionContent } from '@/data/mock';
import { Sparkles } from 'lucide-react';

const VisionSection = () => {
  return (
    <section className="py-20 md:py-32 bg-background relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-amber-500/5 dark:bg-amber-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-64 h-64 bg-foreground/5 rounded-full blur-3xl" />

      <div className="container relative mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 flex items-center justify-center gap-3">
            <Sparkles className="h-8 w-8 text-amber-500 dark:text-amber-400" />
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight">
              {visionContent.title}
            </h2>
          </div>
          
          <div className="bg-background/50 backdrop-blur-sm border border-border/50 rounded-2xl p-8 md:p-12 shadow-xl">
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed text-center">
              {visionContent.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
